import { atom } from 'recoil'
import { CustomerTypes } from 'services'

export const customersList = atom<CustomerTypes[]>({
  key: 'customersList',
  default: []
})
